// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__1rQDi","is-rotating":"styles_is-rotating__0NE9e"};